<template>
  <div class="personal-info-wrapper" ref="wrapperRef">
    <div class="personal-info" ref="contentRef">
      <HDFHeader03 />
      <div class="page-content">
        <PersonalInfoCard />
      </div>
      <HDFFooter03 />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import HDFHeader03 from '@/components/HDFHeader03.vue';
import HDFFooter03 from '@/components/HDFFooter03.vue';
import PersonalInfoCard from '@/components/PersonalInfoCard.vue';

// ===================== 等比例缩放逻辑 =====================
const wrapperRef = ref(null)
const contentRef = ref(null)
const MAX_WIDTH = 1920 // 界面最大宽度
const SCALE_WIDTH = 1920 // 缩放基准宽度

const updateScale = () => {
  if (!wrapperRef.value || !contentRef.value) return
  
  const screenWidth = window.innerWidth
  
  if (screenWidth < SCALE_WIDTH) {
    // 小于1920px时进行等比例缩放
    const scale = screenWidth / SCALE_WIDTH
    
    // 设置容器高度为缩放后的实际高度
    const contentHeight = contentRef.value.scrollHeight
    wrapperRef.value.style.height = `${contentHeight * scale}px`
    
    // 应用缩放
    contentRef.value.style.transform = `scale(${scale})`
    contentRef.value.style.transformOrigin = 'top left'
    contentRef.value.style.margin = '0'
  } else {
    // 大于等于1920px时保持原始大小并居中
    wrapperRef.value.style.height = 'auto'
    contentRef.value.style.transform = 'none'
    contentRef.value.style.margin = '0 auto'
  }
}

onMounted(() => {
  updateScale()
  window.addEventListener('resize', updateScale)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateScale)
})
</script>
<style scoped>
.personal-info-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.personal-info{
  width: 1920px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform-origin: top left;
}
.page-content {
  width: 100%;
}
</style>
